<template>
  <div class="custom-container" v-if="visible">
    <el-dialog :title="$t('merge.customList')" :visible.sync="boxVisible" :close-on-click-modal="false" :before-close="cancel">
      <!-- <el-alert :title="'请选择要显示在列表的信息，最多选择'+optionArr.length+'个'" type="warning" show-icon :closable="false">
      </el-alert> -->
      <!-- <div class="i-text">
        <!-- <div class="tip-earlyWarning mb10" style="line-height: 19px" v-if="optionArr.length > 10">
          {{$t('speechcraft.customlist')}}
        </div> 
      </div> -->
      <div class="custom-list">
        <el-checkbox-group v-model="currentSelect">
          <div class="custom-list-item" v-for="item in optionArr" :key="item.value">
            <!-- <el-checkbox :label="item.value" :disabled="getDisabled(item.value) || (currentSelect.length >= 10 && currentSelect.indexOf(item.value) < 0)">{{item.label}}</el-checkbox> -->
            <el-checkbox :label="item.value" :disabled="getDisabled(item.value)">{{item.label}}</el-checkbox>

          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">{{$t('text.cancel')}}</el-button>
        <el-button type="primary" @click="confirm">{{$t('text.confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    optionArr: {
      type: Array,
      default: []
    },
    type: {
      type: String,
      required: true
    }
  },
  name: 'custom',
  created () {
    for (const value in this.customerInfo) {
      if (this.customerInfo[value].selected) {
        this.currentSelect.push(value);
      }
    }
  },
  computed: {
    customerInfo() {
      return this.$store.state.customInfo[this.type];
    }
  },
  data() {
    return {
      boxVisible: this.visible,
      currentSelect: []
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.boxVisible = newVal;
    }
  },
  methods: {
    getDisabled (value) {
      if (typeof this.customerInfo[value] === 'undefined') {
        return true;
      }
      if (typeof this.customerInfo[value].required !== 'undefined') {
        if (this.customerInfo[value].required == true || this.customerInfo[value].required == 'true') {
          return true;
        }
        return false;
      }
      return false;
    },
    setParam() {
      const cacheInfo = $.extend(true, {}, this.customerInfo);
      for (const value in cacheInfo) {
        cacheInfo[value].selected = false;
      }
      for (const key of this.currentSelect) {
        cacheInfo[key].selected = true;
      }
      return cacheInfo;
    },
    confirm() {
      const param = {
        pageKey: this.type,
        pageValue: null
      };
      param.pageValue = this.setParam();
      this.$api.setCustomInfo(param).then((response) => {
        // var response = JSON.parse(res)
        if (response.errno === 10000) {
          this.$store.commit('GET_CUSTOMINFO', { value: param.pageValue, type: this.type });
          this.$emit('update:visible', false);
        } else {
          this.$message.error(temp.errmsg);
        }
      });
    },
    cancel() {
      this.$emit('update:visible', false);
    }
  }
};
</script>
<style lang="sass">
  @import "./custom"
</style>



// WEBPACK FOOTER //
// src/components/common/custom/Custom.vue